
function getUrlParameter(sParam) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i+=1) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

export default class RegisterLogin {
    constructor() {
        console.info('RegisterLogin.constructor()');

        this.init();
    }

    init() {
        const selector = document.querySelector('.wp-block-group__inner-container');

        const param = getUrlParameter('rr');
        const promptForRR = localStorage.getItem('promptForRR');
        if (param === '1' || promptForRR === 'true') {
            selector.classList.add('rr');
            selector.innerHTML = `
                <h2 class="wp-block-heading">JOIN KINGSFORD NOW!</h2>
                <p class="accent"><strong>Become a Kingsford member for exclusive benefits and online access:</strong></p>
                <ul>
                    <li>Save your favorite Kingsford recipes</li>
                    <li>See exclusive Kingsford content</strong></li>
                    <li>Rate and review products and recipes</li>
                </ul>
                <p class="small"><strong>For a limited time</strong>, members can enter for a chance to win* $500 just for writing a recipe review!</p>
                <p class="disclaimer">*NO PURCHASE NECESSARY. Legal residents of the 50 United States (D.C.) 21 years or older who have an account with kingsford.com. Sweepstakes ends 11/30/23. See <a href="/ratings-and-reviews/" target="_blank">Official Rules</a> for how to enter, odds, alternate method of entry, and prize descriptions. Void where prohibited. Sponsor: The Clorox Company, 1221 Broadway,Oakland, CA 94612.</p>
            `;
        }
    }
}
